import { Box, Grid } from "@mui/material";
import React from "react";
import SectionTitle from "../../components/Typography/SectionTitle";
import { APP_COLORS } from "../../utils/constants";

const expertiseArray = [
  {
    title: "Brand Incubation & Development",
    description:
      "Craft compelling brands from the ground up, ensuring every detail reflects purpose and precision, from concept to market launch.",
  },
  {
    title: "Business Strategy & Execution",
    description:
      "Design and implement strategic blueprints, turning vision into actionable, measurable and sustainable business outcomes.",
  },
  {
    title: "Capital & Fundraising Strategies",
    description:
      "Develop comprehensive capital strategies, through innovative fundraising methodologies, ensuring businesses are investment ready and financially stable on the long term.",
  },
  {
    title: "SMEs Transformation & Scalability",
    description:
      "Enable small and medium-sized enterprises through pivotal growth phases, preparing them to scale sustainably and effectively.",
  },
  {
    title: "Change Management",
    description:
      "Provide a roadmap for managing and implementing significant organizational shifts, with minimal disruption and foster a culture of resilience.",
  },
  {
    title: "Corporate Governance",
    description:
      "Establish robust governance frameworks and best practices hat govern businesses for long-term health and make them investor-ready.",
  },
];
export default function ExpertiseSection({ id }) {
  return (
    <Box
      id={id}
      className="container-fluid section"
      sx={{
        backgroundColor: APP_COLORS.SECONDARY_BACKGROUND,
        px: { lg: "12rem" },
      }}
    >
      <Box
        className="container"
        sx={{ textAlign: "center", color: APP_COLORS.FONT }}
      >
        <SectionTitle title="Our Expertise" centered />

        <p
          style={{
            maxWidth: "930px",
            margin: "0 auto",
            fontSize: { xs: "1rem", lg: "18px" },
            lineHeight: 1.4,
            opacity: 0.9,
            marginTop: "3rem",
          }}
        >
          In a world driven by fast fixes, rubicon® is dedicated to the
          Craftsmanship of Business, delivering solutions that are intentional,
          intelligent, and built to endure.
          <br />
          We enable businesses to grow with clarity, purpose, and resilience
          through our expertise in:
        </p>
      </Box>

      <Grid container spacing={2} sx={{ mt: 5 }}>
        {expertiseArray.map((expertise, index) => (
          <Grid
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{
              backgroundColor: APP_COLORS.SECONDARY,
              color: APP_COLORS.FONT,
              pt: 6,
              px: { xs: 6, lg: 9 },
              pb: 10,
              mx: { xs: 2, lg: 0 },
            }}
            key={index}
          >
            <h3
              style={{
                fontSize: "1.7rem",
                fontWeight: 700,
                marginBottom: "5.5rem",
                height: "4rem",
              }}
            >
              {expertise.title}
            </h3>
            <p
              style={{
                fontSize: "16px",
                lineHeight: 1.5,
                opacity: 0.9,
              }}
            >
              {expertise.description}
            </p>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
